import { getOperationName } from '@apollo/client/utilities';
import { GraphQLError } from 'graphql/error/GraphQLError';

import { ErrorCode } from '~/generated/graphql/cocolocala-bff';
import {
  GraphQLAuthenticationError,
  GraphQLForbiddenError,
  GraphQLInternalError,
  GraphQLNotFoundError,
  GraphQLRedirectError,
} from '~/repository/graphql/cocolocala-bff/errors';

/**
 * GraphQLClientを使ったサーバからのリクエストで返ってきたエラーの変換処理
 * @param document
 * @param error
 * @param variables
 */
export const convertGraphQLClientErrorToGraphQLError = (
  document,
  error,
  variables
) => {
  if (error?.response?.errors?.[0] && error.response.errors[0].extensions) {
    // リダイレクトのエラーのときに
    if (
      error.response.errors[0].extensions.code === ErrorCode.Redirect &&
      typeof error.response.errors[0].extensions.statusCode === 'number' &&
      typeof error.response.errors[0].extensions.location === 'string'
    ) {
      return new GraphQLRedirectError(
        error.response.errors[0].extensions.statusCode,
        error.response.errors[0].extensions.location,
        error.response.errors[0].message
      );
    } else if (
      error.response.errors[0].extensions.code === ErrorCode.NotFound
    ) {
      return new GraphQLNotFoundError(error.response.errors[0].message);
    } else if (
      error.response.errors[0].extensions.code === ErrorCode.Forbidden
    ) {
      return new GraphQLForbiddenError(error.response.errors[0].message);
    } else if (
      error.response.errors[0].extensions.code === ErrorCode.Unauthenticated
    ) {
      return new GraphQLAuthenticationError(error.response.errors[0].message);
    }
  }
  return new GraphQLInternalError(
    JSON.stringify({
      title: 'GraphQLRequestError',
      message:
        error?.response?.errors?.map(err => err.message)?.join('\n') ?? '',
      operationName: getOperationName(document),
      variables: variables,
    })
  );
};

/**
 * Apolloを使ったクライアントからのリクエストで返ってきたエラーから先頭を取り出す
 * @param errors
 */
export const pickFirstAlertMessageFromApolloErrors = (
  errors: GraphQLError[]
): string | undefined => {
  return Array.isArray(errors) && errors.length > 0
    ? errors[0].extensions?.alertMessage
    : undefined;
};
